<template>
  <a class="offer-card" :href="url" @click.prevent>
    <div class="grid-x grid-margin-x">
      <div class="small-12 cell">
        <div class="offer-card__carousel" @click.stop.prevent>
          <div @mouseover.stop="toggleCursor(false)">
            <swiper ref="mySwiper" :options="cardSwiperConfig" v-if="card.images">
              <swiper-slide v-for="image in card.images" :key="image" class='offer-card__aspect-ratio'>
                <img
                  :data-src="publicPath(image)"
                  alt
                  class="swiper-lazy of-cover"
                />
              </swiper-slide>
              <template slot="pagination">
                <div
                  class="circle-32 bg-white carousel-button carousel-button--prev offer-card__button flex-container align-center align-middle"
                  data-prev
                >
                  <svg width="5" height="10" class="inline-block-middle">
                    <use xlink:href="#chevron-small" />
                  </svg>
                </div>
                <div
                  class="circle-32 bg-white carousel-button carousel-button--next offer-card__button flex-container align-center align-middle"
                  data-next
                >
                  <div class="scale-x--1">
                    <svg width="5" height="10">
                      <use xlink:href="#chevron-small" />
                    </svg>
                  </div>
                </div>
              </template>
            </swiper>
          </div>
          <div class="offer-card__carousel-bottom grid-x align-bottom">
            <div class="shrink cell" v-if="card.isNewProject">
              <span
                class="bg-red offer-tag-accent t-small uppercase fw-500 inline-block-top"
                >{{localization.newProject}}</span
              >
            </div>
            <div class="auto cell text-right">
              <svg
                width="30"
                height="40"
                viewBox="0 0 24 24"
                class="white-icon-spacing inline-block-middle"
                v-if="card.videoUrl"
              >
                <use xlink:href="#film" />
              </svg>
              <svg
                width="40"
                height="40"
                viewBox="0 0 32 32"
                class="white-icon-spacing inline-block-middle"
                v-if="card.link360"
              >
                <use xlink:href="#360" />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div
        class="offer-card__content small-12 cell flex-container flex-dir-column"
      >
        <h3 class="t-card mb-8 o-h" v-text="card.title" :class="titleClass"></h3>
        <p
          v-if="showDescription"
          class="o-05 t-p-medium single-line-ellipsis mb-16"
          :title="card.description"
          v-text="card.description"
        ></p>
        <div class="pt-16">
          <p class="t-p-medium fw-500 small-12 medium-auto cell mb-16">
            <span v-if="displayPricePerSqm && card.priceM2an != null">
              <sub class="inline-block-bottom t-small-uppercase lh-20">CHF</sub>
              <span v-text="formatPriceNumber(card.priceM2an)"></span><span>.-</span>
              <span>{{localization.perSqmPerMonth}}</span>
            </span>
            <span v-else-if="!displayPricePerSqm && card.price != null">
              <sub class="inline-block-bottom t-small-uppercase lh-20">CHF</sub>
              <span v-text="formatPriceNumber(card.price)"></span><span>.-</span>
              <span v-if="card.isForRent">{{localization.perMonth}}</span>
            </span>
            <span v-else-if="card.isForRent">{{localization.rentUponRequest}}</span>
            <span v-else>{{localization.priceUponRequest}}</span>
          </p>
          <p class="offer-tags-spacing" v-if="card.tags">
            <span
              class="offer-tag t-label-regular inline-block-top bg-light-gray"
              v-for="tag in card.tags"
              :key="tag"
              v-html="tag"
            ></span>
          </p>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
import displayPricesMixin from './mixins/display-prices-mixin'
import cardCarouselMixin from './mixins/card-carousel-mixin'
import toggleCursorMixin from './mixins/toggle-cursor-mixin'
import publicPathMixin from './mixins/public-path-mixin'

export default {
  name: 'Card',
  mixins: [
    displayPricesMixin,
    cardCarouselMixin,
    toggleCursorMixin,
    publicPathMixin,
  ],
  props: {
    card: {
      type: Object,
      required: true,
    },
    showDescription: {
      type: Boolean,
    },
    titleClass: {
      type: String,
    },
    url: {
      type: String,
      default: '#',
    },
    displayPricePerSqm: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.swiper) {
        this.swiper.update()
      }
    }, 0)
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper && this.$refs.mySwiper.$swiper
    },
  },
  watch: {
    card() {
      if (this.swiper) {
        setTimeout(() => {
          this.swiper.slideToLoop(0, 0)
          this.swiper.lazy.load()
        }, 0)
      }
    },
  },
  data() {
    return {
      localization: window.localization || {}
    }
  }
}
</script>
